module.exports = __webpack_public_path__ + "img/background.f24b08ab.png";